@if (!!this.formGroup) {
@if (this.type === 'textarea') {
<div class="row align-items-start">
  <div class="col-12">
    {{this.label}}
  </div>
  <div class="col-12" style="padding-top: 2px; padding-left: 0px; padding-right: 32px; padding-bottom: 20px; display: flex;" [formGroup]="this.formGroup">
    <textarea class="form-control" [name]="this.id" [formControlName]="this.id"></textarea>
    @if (this.flagged){
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#C8102E" class="bi bi-flag-fill" viewBox="0 0 16 16" color="#C8102E" style="margin-left: 16px; margin-top: 24px;">
      <path d="M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12 12 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A20 20 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a20 20 0 0 0 1.349-.476l.019-.007.004-.002h.001" />
      <title>This answer should have documentation and clarification included.</title>
    </svg>
    }
  </div>
</div>
} @else if (this.type === 'detail') {
<div class="row align-items-start" style="padding-bottom: 12px;">
  <div class="col-12" style="font-weight: bold; white-space: nowrap;">
    {{this.label}}
  </div>
  <div class="col-12" style="white-space: nowrap;">
    {{this.value}}
  </div>
</div>
} @else {
<div class="row align-items-start" style="padding-bottom: 20px;">
  <div class="col-12" [innerHTML]="this.label | safeHtml">
  </div>
  <div class="col-12" style="padding-left: 16px; padding-right: 16px;" [formGroup]="this.formGroup">
    @if (this.type === 'yesno') {
    <div style="padding-top: 8px; padding-bottom: 8px;">
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" [name]="this.id" id="inlineRadio1" [formControlName]="this.id" value="yes">
        <label class="form-check-label" for="inlineRadio1">Yes</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" [name]="this.id" id="inlineRadio2" [formControlName]="this.id" value="no">
        <label class="form-check-label" for="inlineRadio2">No</label>
      </div>
      @if (this.flagged){
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#C8102E" class="bi bi-flag-fill" viewBox="0 0 16 16" color="#C8102E">
        <path d="M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12 12 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A20 20 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a20 20 0 0 0 1.349-.476l.019-.007.004-.002h.001" />
        <title>This answer should have documentation and clarification included.</title>
      </svg>
      }
    </div>
    } @else if (this.type === 'datepicker') {
    <div class="col-8">
      <div class="input-group">
        <input class="form-control" placeholder="mm-dd-yyyy" [name]="this.id" [formControlName]="this.id" ngbDatepicker #d="ngbDatepicker" />
        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()" type="button"></button>
        @if (this.flagged){
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#C8102E" class="bi bi-flag-fill" viewBox="0 0 16 16" color="#C8102E" style="margin-left: 16px; margin-top: 12px;">
          <path d="M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12 12 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A20 20 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a20 20 0 0 0 1.349-.476l.019-.007.004-.002h.001" />
          <title>This answer should have documentation and clarification included.</title>
        </svg>
        }
      </div>
    </div>
    } @else if (this.type === 'custom') {
    <div style="padding-top: 8px; padding-bottom: 8px;">
      @for (value of this.values; track value; let i = $index) {
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" [name]="this.id" id="inlineRadio{{i}}" [formControlName]="this.id" value="{{value.value}}">
        <label class="form-check-label" for="inlineRadio{{i}}">{{value.label}}</label>
      </div>
      }
      @if (this.flagged){
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#C8102E" class="bi bi-flag-fill" viewBox="0 0 16 16" color="#C8102E">
        <path d="M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12 12 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A20 20 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a20 20 0 0 0 1.349-.476l.019-.007.004-.002h.001" />
        <title>This answer should have documentation and clarification included.</title>
      </svg>
      }
    </div>
    } @else if (this.type === 'number') {
    <div style="padding-top: 2px; padding-bottom: 2px;">
      <input type="number" class="form-control" id="quantityInput" [name]="this.id" [formControlName]="this.id">
      @if (this.flagged){
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#C8102E" class="bi bi-flag-fill" viewBox="0 0 16 16" color="#C8102E">
        <path d="M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12 12 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A20 20 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a20 20 0 0 0 1.349-.476l.019-.007.004-.002h.001" />
        <title>This answer should have documentation and clarification included.</title>
      </svg>
      }
    </div>
    }
  </div>
</div>
}
}
